import { isIncludedIn } from "./helpers";
var DateRangeEventHandler = /** @class */ (function () {
    function DateRangeEventHandler(from, to) {
        this.from = from;
        this.to = to;
    }
    DateRangeEventHandler.prototype.getStatus = function (from, to) {
        var isAvailable = isIncludedIn(from, to, this.from, this.to);
        if (!isAvailable) {
            return {
                isAvailable: isAvailable,
                reason: "Does not intersect",
                debug: this,
                data: {},
                from: from, to: to,
                name: this.constructor.name
            };
        }
        return {
            isAvailable: isAvailable,
            data: {},
            name: this.constructor.name,
            from: this.from,
            to: this.to
        };
    };
    return DateRangeEventHandler;
}());
export { DateRangeEventHandler };
